export const usePageData = defineStore('pageData', () => {
  // for saving multiple pageData
  const pageDataMap = ref({
    // { `storeKey` : pageData }
  })

  const pageData = reactive({
    page: 1,
    totalCount: 0,
    //pageCount: 0,
    itemsPerPage: 15,
    showPage: 10,
    preservePage: 0,
    navPage: 1 // page for navigation at detail page
  })

  function setStorePageData(val) {
    if (!val || !val.storeKey) {
      return
    }

    pageDataMap[val.storeKey] = val.pageData
  }

  function getStorePageData(storeKey) {
    return pageDataMap[`${storeKey}`]
  }

  return {
    pageDataMap,
    setStorePageData,
    getStorePageData,
    pageData
  }
})
